import { withNaming } from '@bem-react/classname';

export default withNaming({ n: '', e: '__', m: '_', v: '_' });
